import { Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TextBox from '../../components/TextBox'
import { Business, CreditCard, CreditScore, Edit, Map, Phone, Pin, SaveAs } from '@mui/icons-material'
import RadioButton from '../../components/RadioButton'
import TextArea from '../../components/TextArea'
import TextCurrency from '../../components/TextCurrency'
import CustomSwitch from '../../components/CustomSwitch'
import API from '../../services/api'
import CustomSnackBar from '../../components/CustomSnackBar'
import { useNavigate, useParams } from 'react-router-dom'
import ButtonSubmit from '../../components/ButtonSubmit'
import ButtonBack from '../../components/ButtonBack'
import MainText from '../../components/MainText'
import SupplierAbastoConfig from './SupplierAbastoConfig'

const BANK_REQUISITION_FLOW = 'BANK_REQUISITION'

function EditSupplier() {
  const { id } = useParams();
  const uri = `/suppliers/${id}/`;
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");
  const [formData, setFormData] = useState({
    companyName: '',
    legalName: '',
    address: '',
    taxNumber: 0,
    phone: 0,
    creditPeriod: 0,
    creditLimit: 0,
    comment: '',
    whagent: true,
    all_products: false,
    isCredit: true,
    payment_flow_type: 'NORMAL',
    abasto_bank_name: '',
    abasto_agreement_name: '',
    abasto_agreement_number: '',
    abasto_interest_rate: '',
  })


  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    console.log(formData)
  }

  const isAbasto = formData.payment_flow_type === BANK_REQUISITION_FLOW;

  const handleFlowChange = (name, enabled) => {
    setFormData((prev) => ({
      ...prev,
      payment_flow_type: enabled ? BANK_REQUISITION_FLOW : 'NORMAL',
      isCredit: enabled ? true : prev.isCredit,
    }));
  }

  const normalizePayload = (data) => {
    const trimValue = (v) => (typeof v === 'string' ? v.trim() : v);
    const interestRate = trimValue(data.abasto_interest_rate);
    return {
      ...data,
      companyName: trimValue(data.companyName),
      legalName: trimValue(data.legalName),
      address: trimValue(data.address),
      taxNumber: trimValue(data.taxNumber),
      abasto_bank_name: trimValue(data.abasto_bank_name),
      abasto_agreement_name: trimValue(data.abasto_agreement_name),
      abasto_agreement_number: trimValue(data.abasto_agreement_number),
      abasto_interest_rate: interestRate === '' || interestRate === undefined ? null : interestRate,
    };
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await API.get(uri);
        const data = response.data;
        console.log(data)
        setFormData({
          companyName: data.companyName || '',
          legalName: data.legalName || '',
          address: data.address || '',
          taxNumber: data.taxNumber || 0,
          phone: data.phone || 0,
          creditPeriod: data.creditPeriod || 0,
          creditLimit: data.creditLimit || 0,
          comment: data.comment || '',
          whagent: data.whagent ?? true,
          all_products: data.all_products ?? false,
          isCredit: data.isCredit ?? true,
          payment_flow_type: data.payment_flow_type || 'NORMAL',
          abasto_bank_name: data.abasto_bank_name || '',
          abasto_agreement_name: data.abasto_agreement_name || '',
          abasto_agreement_number: data.abasto_agreement_number || '',
          abasto_interest_rate: data.abasto_interest_rate ?? '',
        });
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = normalizePayload(formData);
      await API.patch(uri, payload);
      setOpenSnack(true);
      setSnackMessage("¡Actualizado con éxito!");
      setSnackSeverity("success");
      setTimeout(() => {
        setLoading(true);
        navigate('/suppliers/all-suppliers');
      }, 1500)

    } catch (error) {
      setOpenSnack(true);
      console.log(error);
      setSnackMessage("Algo salio mal intente de nuevo");
      setSnackSeverity("error");
      setLoading(false);
    }

  }

  return (
    <form onSubmit={handleSubmit}>

      <MainText
        title={'Editar proveedor'}
        subtitle={'Modifica la información'}
        icon={SaveAs}
      />
      <Stack
        spacing={5}
        direction={{ sx: 'column', sm: 'row' }}
        fullWidth
      >
        <TextBox
          label={'Nombre de la empresa'}
          icon={Business}
          type='text'
          required
          minLength={0}
          maxLength={24}
          errorMessage='Campo requerido'
          name={'companyName'}
          newValue={formData.companyName}
          onChange={handleChange}

        />
        <TextBox
          label={'Nombre de razón social'}
          icon={Business}
          type='text'
          required
          minLength={0}
          maxLength={30}
          errorMessage='Campo requerido'
          name={'legalName'}
          newValue={formData.legalName}
          onChange={handleChange}
          fullWidth
        />
      </Stack>
      <TextBox
        label={'Dirección'}
        icon={Map}
        type='text'
        required
        minLength={0}
        maxLength={29}
        width={'595px'}
        errorMessage='Campo requerido'
        name={'address'}
        newValue={formData.address}
        onChange={handleChange}
      />
      <Stack
        spacing={5}
        direction={{ sx: 'column', sm: 'row' }}
        fullWidth
      >
        <TextBox
          label={'Nit'}
          icon={Pin}
          type='number'
          required
          minLength={0}
          maxLength={15}
          errorMessage='Válide que sea nit'
          name={'taxNumber'}
          newValue={formData.taxNumber}
          onChange={handleChange}
        />
        <TextBox
          label={'Número de teléfono'}
          icon={Phone}
          type='number'
          required
          minLength={0}
          maxLength={8}
          errorMessage='Campo requerido'
          name={'phone'}
          newValue={formData.phone}
          onChange={handleChange}
        />
      </Stack>
      {!isAbasto && (
      <RadioButton
        name={'isCredit'}
        onChange={handleChange}
        initialValue={formData.isCredit}
        renderCreditFields={() => (

          <Stack spacing={2} direction={{ sx: 'column', sm: 'row' }}>
            <TextBox
              label={'Dias de crédito'}
              icon={CreditCard}
              type='number'
              required
              minLength={0}
              maxLength={2}
              errorMessage='Campo requerido'
              name={'creditPeriod'}
              newValue={formData.creditPeriod}
              onChange={handleChange}
            />
            <TextCurrency
              label='Límite de credito'
              icon={CreditScore}
              required
              maxLength={10}
              name={'creditLimit'}
              newValue={formData.creditLimit}
              onChange={handleChange}
            />
          </Stack>
        )

        } />
      )}
      <TextArea name={"comment"} onChange={handleChange} newValue={formData.comment} />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1 }}>
        <CustomSwitch name={"whagent"} onChange={handleChange} label={'Agente de retención'} initialValue={formData.whagent} />
        <CustomSwitch
          name={"all_products"}
          onChange={handleChange}
          label={'Mostrar todos los productos'}
          initialValue={Boolean(formData.all_products)}
        />
        <CustomSwitch
          name="abasto_flow"
          onChange={handleFlowChange}
          label="Flujo"
          uncheckedLabel="Normal"
          checkedLabel="Abasto"
          initialValue={isAbasto}
        />
      </Stack>
      {isAbasto && (
        <SupplierAbastoConfig formData={formData} onChange={handleChange} />
      )}
      <Stack spacing={2} direction={"row"}>
        <ButtonSubmit name="Actualizar" icon={Edit} loading={loading} />
        <ButtonBack />
      </Stack>
      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
      )};

    </form>
  )
}

export default EditSupplier
